import { FETCH_AGES_SUCCESS, FETCH_REGISTRY, FETCH_REGISTRY_SUCCESS } from './types'
import { criteriaIds } from 'common/criteria'

const initialState = {
  ages: [],
  criteria: [],
  criteriaItems: [],
  orientations: [],
  sexes: [],
  countries: [],
  zodiacs: [],
  languages: [],
  adultRatings: [],
  feedbackReasons: [
    { id: 101, name: 'Pricing and payments' },
    { id: 108, name: 'Communication with site members' },
    { id: 102, name: 'Profile questions' },
    { id: 122, name: 'Violation report' },
    { id: 104, name: 'Experiencing technical difficulties' },
    { id: 126, name: 'Deleting my profile' },
    { id: 125, name: 'General inquiry' },
  ],
  subscriptionSuspendReasons: [],
  loading: [],
}

const registry = (state = initialState, { type, meta, payload }) => {
  if (type == FETCH_AGES_SUCCESS) {
    return { ...state, ages: payload.map(e => ({ id: e, name: e })) }
  }
  if (!type.includes(FETCH_REGISTRY)) {
    return state
  }
  const ids = meta.url
    .replace(/.*ids=/, '')
    .split(',')
    .map(e => +e)
  const loading = type == FETCH_REGISTRY ? state.loading.concat(ids) : state.loading.filter(e => !ids.includes(e))
  if (type != FETCH_REGISTRY_SUCCESS) {
    return { ...state, loading }
  }
  const { criterionItems: criteriaItems, ...loaded } = payload
  criteriaItems &&
    Object.assign(loaded, {
      criteriaItems,
      languages: criteriaItems.filter(e => e.parentCriterionId == criteriaIds.languages),
    })
  if (loaded.countries) {
    loaded.countries = loaded.countries.map(e => ({ ...e, name: e.shortName, longName: e.name }))
  }
  if (loaded.orientations) {
    loaded.orientations = loaded.orientations.map(e => ({ ...e, name: e.nameAsLookingFor, shortName: e.name }))
  }
  return { ...state, loading, ...loaded }
}

export default registry
